<div class= "Container">
    <div class= "Container-title">
        <h1>{{data.labelMensagem}}</h1>
    </div>
    <div class = "Container-button">
        <button [mat-dialog-close]="true">{{data.labelConfirmacao}}</button>
        <button [mat-dialog-close]="false">{{data.labelNegacao}}</button>
    </div>
</div>
